import { css } from 'styled-components';

import alertStyles from './alert';
import btnStyles from './btn';
import cascaderStyles from './cascader';
import checkboxStyles from './checkbox';
import formStyles from './form';
import inputStyles from './input';
import menuStyles from './menu';
import modalStyles from './modal';
import paginationStyles from './pagination';
import pickerStyles from './picker';
import radioStyles from './radio';
import selectStyles from './select';
import stepsStyles from './steps';
import tableStyles from './table';
import tabsStyles from './tabs';
import breadcrumb from './breadcrumb';

export default css`
  ${alertStyles};
  ${btnStyles};
  ${cascaderStyles};
  ${checkboxStyles};
  ${formStyles};
  ${inputStyles};
  ${menuStyles};
  ${modalStyles};
  ${paginationStyles};
  ${pickerStyles};
  ${radioStyles};
  ${selectStyles};
  ${stepsStyles};
  ${tableStyles};
  ${tabsStyles};
  ${breadcrumb};
`;
